<template>
    <div  >
            <top-navbar></top-navbar>


            <div  class="mb-5  background_color " >


                <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Maintainence Management   </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/pdf/index">Maintainence List</router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Save File</h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
                <div style=" padding-bottom: 100px;" class="container-fluid ">


  <div class="card custom_bdr_rds shadow p-2">
                <div class="card-body custom_bdr_rds">


                    <table style="font-size: small; " class="table table-hover  table-sm table-borderless  ">

                        <tbody >


                          <tr>
                            <td class="width-custom2"><b>Supplier </b></td>
                           <td>Boeing</td>
                          </tr>
                          <tr>
                            <td><b>Model & Series  </b></td>
                           <td>737-8</td>
                          </tr>
                          <tr>
                            <td><b>Aircraft Number </b></td>
                           <td>1K016</td>
                          </tr>

                          <tr>
                            <td><b>Aircraft Serial Number   </b></td>
                           <td>44304</td>
                          </tr>
                          <tr>
                            <td><b>Line Number  </b></td>
                           <td>4488</td>
                          </tr>
                          <tr>
                            <td><b>Engine Serial Number 1 </b></td>
                           <td></td>
                          </tr>
                          <tr>
                            <td><b>Engine Serial Number 2 </b></td>
                           <td></td>
                          </tr>
                          <tr>
                            <td><b>APU Serial Number</b></td>
                           <td></td>
                          </tr>
                          <tr>
                            <td><b>Landing Serial Number </b></td>
                           <td></td>
                          </tr>




                        </tbody>


                      </table>



           <div class="d-flex align-items-center">
  <!-- Tabs -->
 <b-col style="margin-left: -10px;" cols="12" md="" class="">
      <b-button @click="tab1()" variant="outline-primary" size="sm" class=" bdr-rad me-1 mb-1">
        Detailed Specification
      </b-button>
      <b-button @click="tab2()" variant="outline-primary" size="sm" class=" bdr-rad me-1 mb-1">
       ARL
      </b-button>
      <b-button @click="tab3()" variant="outline-primary" size="sm" class=" bdr-rad me-1 mb-1">
    Airworthiness Directive
      </b-button>
      <b-button @click="tab4()" variant="outline-primary" size="sm" class=" bdr-rad me-1 mb-1">
   MPD 01-01-2024
      </b-button>
      <b-button @click="tab5()" variant="outline-primary" size="sm" class=" bdr-rad me-1 mb-1">
    MPD 15-9-2024
      </b-button>
     
    </b-col>

  <!-- Advanced Search tab aligned to the right -->
   <div class=" ms-auto">

      <button class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad" @click="tab6()">Advanced Search</button>

  </div>
</div>



   <div class="mt-1 ms-1"  v-for="pdffile in pdffiles" :key="pdffile.id">
            <a v-show="id==pdffile.id" @click="loadsavefile(pdffile.id)"  class="mb-1 mt-0 link_a2">
            {{ pdffile.file_name }}
          </a>
            <a v-show="id!=pdffile.id"  @click="loadsavefile(pdffile.id)"  class="mb-1 mt-0 link_a">
            {{ pdffile.file_name }}
          </a>
          </div>




                </div>
                </div>









                <div class="card bdr-rad2 mt-1 shadow p-2 ">
                <div class="card-body">

  <div class="d-flex justify-content-between align-items-center mb-2">
  <button class="btn btn-outline-primary btn-sm bdr-rad" @click="Remove()">Remove</button>

  <div class="text-end">
    <a style="cursor: pointer;" @click="exportTableToExcel">
      <img
        style="padding-left: 5px"
        src="../../../public/img/excel.png"
        width="70px"
        alt="Evenware Logo"
      />
    </a>
  </div>
</div>



      <br>

      <div>
      <div v-if="table1" style="border: 0px; padding: 0px; min-height:0px" class="navbar ">

        <div class="d-flex">
          <div  class="" >
          <span class="custom-breadcrumb"><b>Showing  {{totalRowsarl}} items.   ARL</b></span>
          </div>

        </div>


        <div class="d-grid gap-2 d-md-flex justify-content-md-end">

        </div>

      </div>


 <div v-if="table1" class="table-responsive">


   <b-table
  responsive
  style="font-size: small;"
  class="table-hover"
  :items="filteredDataArl"
  :fields="visibleFieldsarl"
  head-variant="dark"
  show-empty
  small
>
    <template #cell(check_box)="row">
  <b-form-checkbox v-model="row.item.selected" />
</template>


    <template #cell(file_upload)="row">
    
   <input v-show="row.item.task_file_url==''" type="file" @change="handleFileUpload($event, 1, row.item.id)" class="form-control bdr-rad chose-font" />

  <a
  v-if="row.item.task_file_url && row.item.task_file_url.trim() !== ''"
  :href="`/${row.item.task_file_url}`"
  target="_blank"
  class="d-flex align-items-center"
>
  <i  class="fas fa-file-pdf" style="color: red; margin-right: 5px;"></i>
   <img
        style="padding-left: 5px"
        src="../../../public/img/pdf_logo_medium.png"
        width="35px"
        alt="Evenware Logo"
      />
</a>

   
</template>



    <template #cell(date)="row">
     <input type="text" v-model="alldata10.number" class="form-control bdr-rad" />
</template>
<template #head(mpd_mid)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input
      v-model="columnFilters.mpd_mid"
      placeholder="Search"
      size="sm"
    />
  </div>
</template>

<template #head(part_num_dis)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input
      v-model="columnFilters.part_num_dis"
      placeholder="Search"
      size="sm"
    />
  </div>
</template>

<template #head(cage_code)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input
      v-model="columnFilters.cage_code"
      placeholder="Search"
      size="sm"
    />
  </div>
</template>

<template #head(qty)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input
      v-model="columnFilters.qty"
      placeholder="Search"
      size="sm"
    />
  </div>
</template>

<template #head(serial)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input
      v-model="columnFilters.serial"
      placeholder="Search"
      size="sm"
    />
  </div>
</template>

<template #head(misc_loc)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input
      v-model="columnFilters.misc_loc"
      placeholder="Search"
      size="sm"
    />
  </div>
</template>
    </b-table>

  </div>



  <div v-if="table2" style="border: 0px; padding: 0px; min-height:0px" class="navbar ">

        <div class="d-flex">
          <div  class="" >
          <span class="custom-breadcrumb"><b>Showing  {{totalRowsad}} items.  Airworthiness Directive</b></span>
          </div>

        </div>


        <div class="d-grid gap-2 d-md-flex justify-content-md-end">

        </div>

      </div>


   <div v-if="table2" class="table-responsive">


   <b-table
  responsive
  style="font-size: small;"
  class="table-hover"
  :items="filteredDataAd"
  :fields="visibleFieldsad"
  head-variant="dark"
  show-empty
  small
>
    <template #cell(check_box)="row">
  <b-form-checkbox v-model="row.item.selected" />
</template>

 <template #cell(file_upload)="row">
    
   <input v-show="row.item.task_file_url==''" type="file" @change="handleFileUpload($event, 2, row.item.id)" class="form-control bdr-rad chose-font" />

  <a
  v-if="row.item.task_file_url && row.item.task_file_url.trim() !== ''"
  :href="`/${row.item.task_file_url}`"
  target="_blank"
  class="d-flex align-items-center"
>
  <i  class="fas fa-file-pdf" style="color: red; margin-right: 5px;"></i>
  <img
        style="padding-left: 5px"
        src="../../../public/img/pdf_logo_medium.png"
        width="35px"
        alt="Evenware Logo"
      />
</a>

   
</template>


<template #head(ad_number)="data">
    <div class="d-flex flex-column">
      <span>{{ data.label }}</span>
      <b-form-input
        v-model="columnFiltersAd.ad_number"
        placeholder="Search"
        size="sm"
      />
    </div>
  </template>

  <template #head(amendment)="data">
    <div class="d-flex flex-column">
      <span>{{ data.label }}</span>
      <b-form-input
        v-model="columnFiltersAd.amendment"
        placeholder="Search"
        size="sm"
      />
    </div>
  </template>

  <template #head(assigned)="data">
    <div class="d-flex flex-column">
      <span>{{ data.label }}</span>
      <b-form-input
        v-model="columnFiltersAd.assigned"
        placeholder="Search"
        size="sm"
      />
    </div>
  </template>

  <template #head(subject)="data">
    <div class="d-flex flex-column">
      <span>{{ data.label }}</span>
      <b-form-input
        v-model="columnFiltersAd.subject"
        placeholder="Search"
        size="sm"
      />
    </div>
  </template>

  <template #head(compliance)="data">
    <div class="d-flex flex-column">
      <span>{{ data.label }}</span>
      <b-form-input
        v-model="columnFiltersAd.compliance"
        placeholder="Search"
        size="sm"
      />
    </div>
  </template>

  <template #head(additional_information)="data">
    <div class="d-flex flex-column">
      <span>{{ data.label }}</span>
      <b-form-input
        v-model="columnFiltersAd.additional_information"
        placeholder="Search"
        size="sm"
      />
    </div>
  </template>
    </b-table>

  </div>





   <div v-if="table3" style="border: 0px; padding: 0px; min-height:0px" class="navbar ">

        <div class="d-flex">
          <div  class="" >
          <span class="custom-breadcrumb"><b>Showing  {{totalRowsmpdjan}} items.  Mpd 01-01-2024</b></span>
          </div>

        </div>


        <div class="d-grid gap-2 d-md-flex justify-content-md-end">

        </div>

      </div>


   <div v-if="table3" class="table-responsive">


   <b-table
  responsive
  style="font-size: small;"
  class="table-hover table-responsive"
  :items="filteredDataMpdjan"
  :fields="visibleFieldsmpdjan"
  head-variant="dark"
  show-empty
  small
>
       <template #cell(check_box)="row">
  <b-form-checkbox v-model="row.item.selected" />
</template>

 <template #cell(file_upload)="row">
    
   <input v-show="row.item.task_file_url==''" type="file" @change="handleFileUpload($event, 3, row.item.id)" class="form-control bdr-rad chose-font" />

  <a
  v-if="row.item.task_file_url && row.item.task_file_url.trim() !== ''"
  :href="`/${row.item.task_file_url}`"
  target="_blank"
  class="d-flex align-items-center"
>
  <i  class="fas fa-file-pdf" style="color: red; margin-right: 5px;"></i>
 <img
        style="padding-left: 5px"
        src="../../../public/img/pdf_logo_medium.png"
        width="35px"
        alt="Evenware Logo"
      />
</a>

   
</template>


<template #head(section)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.section" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(item)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.item" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(item_number)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.item_number" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(mrb_item_number)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.mrb_item_number" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(amm_reference)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.amm_reference" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(pgm)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.pgm" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(cat)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.cat" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(task)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.task" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(task_card_number)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.task_card_number" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(related_task_card_number)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.related_task_card_number" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(task_title)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.task_title" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(thres)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.thres" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(repeat)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.repeat" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(zone)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.zone" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(access)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.access" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(apl)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.apl" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(eng)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.eng" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(main_hours)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.main_hours" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(description_of_change)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.description_of_change" placeholder="Search" size="sm" />
  </div>
</template>

    </b-table>

  </div>


   <div v-if="table4" style="border: 0px; padding: 0px; min-height:0px" class="navbar ">

        <div class="d-flex">
          <div  class="" >
          <span class="custom-breadcrumb"><b>Showing  {{totalRowsmpdsep}} items. Mpd 15-09-2024</b></span>
          </div>

        </div>


        <div class="d-grid gap-2 d-md-flex justify-content-md-end">

        </div>

      </div>


   <div v-if="table4" class="table-responsive">

<b-table
  responsive
  class="table-hover table-responsive"
  style="font-size: small;"
 :items="filteredDataMpdsep"
  :fields="visibleFieldsmpdsep"
  head-variant="dark"
  show-empty
  small
>
     <template #cell(check_box)="row">
  <b-form-checkbox v-model="row.item.selected" />
</template>

 <template #cell(file_upload)="row">
    
   <input v-show="row.item.task_file_url==''" type="file" @change="handleFileUpload($event, 4, row.item.id)" class="form-control bdr-rad chose-font" />

  <a
  v-if="row.item.task_file_url && row.item.task_file_url.trim() !== ''"
  :href="`/${row.item.task_file_url}`"
  target="_blank"
  class="d-flex align-items-center"
>
  <i  class="fas fa-file-pdf" style="color: red; margin-right: 5px;"></i>
 <img
        style="padding-left: 5px"
        src="../../../public/img/pdf_logo_medium.png"
        width="35px"
        alt="Evenware Logo"
      />
</a>

   
</template>

  <template v-for="field in Object.keys(columnFiltersMpdsep)" v-slot:[`head(${field})`]="data">
    <div class="d-flex flex-column">
      <span>{{ data.label }}</span>
      <b-form-input
        v-model="columnFiltersMpdsep[field]"
        placeholder="Search"
        size="sm"
      />
    </div>
  </template>
    </b-table>

  </div>




      </div>


<div v-if="showPopup" class="popup-overlay">
  <div class="popup-card">
    <!-- Fixed Header -->
    <div class="popup-header">
      <h5>Crop area to extract text</h5>
    </div>

    <!-- Scrollable Content -->
    <div class="popup-body">
      <!-- Show OCR editable box if result exists -->
      

      <!-- PDF Canvas -->
      <canvas v-show="!ocrText"
        ref="pdfCanvas"
        @mousedown="startSelection"
        @mousemove="drawSelection"
        @mouseup="endSelection"></canvas>
    </div>

    <!-- Fixed Footer -->
   <div class="popup-footer ">
  <!-- OCR Result input (left side) -->
   <div v-if="ocrText" class="mb-1">
      <!-- <label class="mb-1">OCR Result (editable):</label>
      <input type="text" v-model="ocrText" class="form-control" /> -->
      <label class="mb-1">Ref:</label>
      <input type="text" v-model="ocr_ref" class="form-control" disabled/>
      <label class="mb-1">Authorised Date</label>
      <input type="text" v-model="ocr_auth_date" class="form-control" />
    </div>

  <!-- Buttons (right side) -->
  <div class="">
    <button class="btn btn-sm btn-secondary mr-1" @click="closePopup">Cancel</button>
    <button v-if="!ocrText" class="btn btn-sm btn-primary" @click="runOcr">Save</button>
    <button v-else class="btn btn-sm btn-success " @click="confirmOcr">Confirm</button>
  </div>
</div>

  </div>
</div>






                </div>
                </div>

            </div>

          </div>

            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
import Table from '@/components/Table.vue'
import Content from '@/layout/Content.vue'



      export default {

        mounted(){
    this.loadMiinventory()

    this.loaddata()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
              'id':this.$route.query.id,
            table1 :false,
            table2 :false,
            table3 :false,
            table4 :false,
            pdffiles:[],
            file: null,
            filename:'',
            pdf_id:'',
            tbl_id:'',

       
      alldata10: {},
      showPopup: false,
      pdfPage: null,
      selection: null,
      isSelecting: false,
      ocrText: "",
       ocr_auth_date: "",
      ocr_ref: "",
            // alldata:{
            //   'keyword':'',
            // },

              rows: [
      {
        selectfile: null,
        selecttab: [],
        keyword: '',
        sections: []
      }
    ],
     columnFilters: {
      mpd_mid: '',
      part_num_dis: '',
      cage_code: '',
      qty: '',
      serial: '',
      misc_loc: ''
    },
    columnFiltersAd: {
  ad_number: '',
  amendment: '',
  assigned: '',
  subject: '',
  compliance: '',
  additional_information: ''
},
columnFiltersMpdjan: {
  section: '',
  item: '',
  item_number: '',
  mrb_item_number: '',
  amm_reference: '',
  pgm: '',
  cat: '',
  task: '',
  task_card_number: '',
  related_task_card_number: '',
  task_title: '',
  thres: '',
  repeat: '',
  zone: '',
  access: '',
  apl: '',
  eng: '',
  main_hours: '',
  description_of_change: ''
},
columnFiltersMpdsep: {
  section: '',
  item: '',
  item_number: '',
  mrb_item_number: '',
  amm_reference: '',
  pgm: '',
  cat: '',
  task: '',
  task_card_number: '',
  related_task_card_number: '',
  task_title: '',
  thres: '',
  repeat: '',
  zone: '',
  access: '',
  apl: '',
  eng: '',
  main_hours: '',
  description_of_change: ''
},


      Fileselcts: [ ],

        filter: null,

        filterOn: [],
        totalRowsarl: 0,
        totalRowsad: 0,
        totalRowsmpdjan: 0,
        totalRowsmpdsep: 0,

        infoModal: {
                id: 'info-modal',
                title: '',
                content: {},
              },

                all_data_arl:[],

                 field_arl: [
          { key: 'check_box', label: 'Select', sortable: true,  },
          { key: 'mpd_mid', label: 'MPD MID#', sortable: true,  },
          { key: 'part_num_dis', label: 'Part Number Part Description', sortable: true  },
          { key: 'cage_code', label: 'Search (Click to sort ascending) Used On/Alt Authority Cage Code/SRC/ATA/LL/PV/AD', sortable: true  },
          { key: 'qty', label: 'Qty', sortable: true  },
          { key: 'serial', label: 'Serial/Lot Number/Dates', sortable: true  },
          { key: 'misc_loc', label: 'Misc Loc/Ref Designator X-Station/Y-BL/Z-Wtr', sortable: true  },
          { key: 'file_upload', label: 'Task Card', sortable: true,thStyle: { width: '120px' }   },
          { key: 'ref_no', label: 'Ref:', sortable: true ,thStyle: { width: '120px' }  },
          { key: 'scan_date', label: 'Task Date', sortable: true ,thStyle: { width: '120px' }  },


        ],


             all_data_ad:[],

                 field_ad: [
                      { key: 'check_box', label: 'Select', sortable: true,  },
          { key: 'ad_number', label: 'AD Number Effective Date', sortable: true,  },
          { key: 'amendment', label: 'Amendment', sortable: true  },
          { key: 'assigned', label: 'Assigned to', sortable: true  },
          { key: 'subject', label: 'Subject', sortable: true  },
          { key: 'compliance', label: 'Compliance/Limitations', sortable: true  },
          { key: 'additional_information', label: 'Follow-on Action / Additional Information', sortable: true  },
          { key: 'file_upload', label: 'Task Card', sortable: true,thStyle: { width: '120px' }   },
          { key: 'ref_no', label: 'Ref:', sortable: true ,thStyle: { width: '120px' }  },
          { key: 'scan_date', label: 'Task Date', sortable: true ,thStyle: { width: '120px' }  },


        ],


             all_data_mpdjan:[],

                 field_mpdjan: [
                      { key: 'check_box', label: 'Select', sortable: true,  },
      { key: 'section', label: 'Section', sortable: true,  },
          { key: 'item', label: 'Item', sortable: true  },
          { key: 'item_number', label: 'MPD ITEM NUMBER', sortable: true  },
          { key: 'mrb_item_number', label: 'MRB ITEM NUMBER', sortable: true  },
          { key: 'amm_reference', label: 'AMM REFERENCE', sortable: true  },
          { key: 'pgm', label: 'PGM', sortable: true  },
          { key: 'cat', label: 'CAT', sortable: true  },
          { key: 'task', label: 'TASK', sortable: true  },
          { key: 'task_card_number', label: 'TASK CARD NUMBER', sortable: true  },
          { key: 'related_task_card_number', label: 'RELATED TASK CARD NUMBER', sortable: true  },
          { key: 'task_title', label: 'TASK TITLE', sortable: true  },
          { key: 'thres', label: 'THRE S.', sortable: true  },
          { key: 'repeat', label: 'REPEAT', sortable: true  },
          { key: 'zone', label: 'ZONE', sortable: true  },
          { key: 'access', label: 'ACCESS', sortable: true  },
          { key: 'apl', label: 'APL', sortable: true  },
          { key: 'eng', label: 'ENG', sortable: true  },
          { key: 'main_hours', label: 'MAIN-HOURS', sortable: true  },
          { key: 'description_of_change', label: 'Description', sortable: true  },
            { key: 'file_upload', label: 'Task Card', sortable: true,thStyle: { width: '120px' }   },
          { key: 'ref_no', label: 'Ref:', sortable: true ,thStyle: { width: '120px' }  },
          { key: 'scan_date', label: 'Task Date', sortable: true ,thStyle: { width: '120px' }  },



        ],


             all_data_mpdsep:[],

                 field_mpdsep: [
                      { key: 'check_box', label: 'Select', sortable: true,  },
           { key: 'section', label: 'Section', sortable: true,  },
          { key: 'item', label: 'Item', sortable: true  },
          { key: 'item_number', label: 'MPD ITEM NUMBER', sortable: true  },
          { key: 'mrb_item_number', label: 'MRB ITEM NUMBER', sortable: true  },
          { key: 'amm_reference', label: 'AMM REFERENCE', sortable: true  },
          { key: 'pgm', label: 'PGM', sortable: true  },
          { key: 'cat', label: 'CAT', sortable: true  },
          { key: 'task', label: 'TASK', sortable: true  },
          { key: 'task_card_number', label: 'TASK CARD NUMBER', sortable: true  },
          { key: 'related_task_card_number', label: 'RELATED TASK CARD NUMBER', sortable: true  },
          { key: 'task_title', label: 'TASK TITLE', sortable: true  },
          { key: 'thres', label: 'THRE S.', sortable: true  },
          { key: 'repeat', label: 'REPEAT', sortable: true  },
          { key: 'zone', label: 'ZONE', sortable: true  },
          { key: 'access', label: 'ACCESS', sortable: true  },
          { key: 'apl', label: 'APL', sortable: true  },
          { key: 'eng', label: 'ENG', sortable: true  },
          { key: 'main_hours', label: 'MAIN-HOURS', sortable: true  },
          { key: 'description_of_change', label: 'Description', sortable: true  },
           { key: 'file_upload', label: 'Task Card', sortable: true,thStyle: { width: '120px' }   },
          { key: 'ref_no', label: 'Ref:', sortable: true ,thStyle: { width: '120px' }  },
          { key: 'scan_date', label: 'Task Date', sortable: true ,thStyle: { width: '120px' }  },


        ],




            sections:[
            { label: 'Section1', value: 'section1' },
            { label: 'Section2', value: 'section2' },
            { label: 'Section3', value: 'section3' },
            { label: 'Section4', value: 'section4' },

          ],

             Fileselcts:[
            { label: 'Detailed Specification', value: 'detailed_specification' },
            { label: 'ARL', value: 'arl' },
            { label: 'Airworthiness Directive', value: 'airworthiness_directive' },
            { label: 'MPD 01-01-2024', value: 'MPD_01-01-2024' },
            { label: 'MPD 15-09-2024', value: 'MPD_15-09-2024' },

          ],


          variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark', 'mycoolor'],
      headerBgVariant: 'mycoolor',
      headerTextVariant: 'light',




          }

        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,

        	Table,
		Content,
	},

  watch: {
  filteredDataMpdsep(newVal) {
    this.totalRowsmpdsep = newVal.length;
  },
  filteredDataArl(newVal) {
    this.totalRowsarl = newVal.length;
  },
  filteredDataAd(newVal) {
    this.totalRowsad = newVal.length;
  },
  filteredDataMpdjan(newVal) {
    this.totalRowsmpdjan = newVal.length;
  }
},

        computed: {

          filteredDataMpdjan() {
    return this.all_data_mpdjan.filter(row => {
      return Object.keys(this.columnFiltersMpdjan).every(key => {
        const filter = this.columnFiltersMpdjan[key].toLowerCase();
        const value = String(row[key] || '').toLowerCase();
        return value.includes(filter);
      });
    });
  },

    totalRowsmpdjan() {
    return this.filteredDataMpdjan.length;


  },


 visibleFieldsmpdjan() {
  return this.field_mpdjan;
},

filteredDataMpdsep() {

    return this.all_data_mpdsep.filter(row => {
      return Object.keys(this.columnFiltersMpdsep).every(key => {
        const filterValue = this.columnFiltersMpdsep[key].toLowerCase();
        const rowValue = String(row[key] || '').toLowerCase();
        return rowValue.includes(filterValue);
      });
    });
  },
  totalRowsmpdsep() {
    return this.filteredDataMpdsep.length;


  },


  visibleFieldsmpdsep() {
  return this.field_mpdsep;
},

 filteredDataArl() {
    return this.all_data_arl.filter(row => {
      return Object.keys(this.columnFilters).every(key => {
        const filter = this.columnFilters[key].toLowerCase();
        const value = String(row[key] || '').toLowerCase();
        return value.includes(filter);
      });
    });
  },

  totalRowsarl() {
    return this.filteredDataArl.length;


  },


visibleFieldsarl() {
  return this.field_arl;
},

  filteredDataAd() {
    return this.all_data_ad.filter(row => {
      return Object.keys(this.columnFiltersAd).every(key => {
        const filter = this.columnFiltersAd[key].toLowerCase();
        const value = String(row[key] || '').toLowerCase();
        return value.includes(filter);
      });
    });
  },

  totalRowsad() {
    return this.filteredDataAd.length;


  },



 visibleFieldsad() {
  return this.field_ad;
},




},

        methods : {

          
       


 handleFileUpload(event, pdf_id, tbl_id) {
  
      this.file = event.target.files[0];
         this.pdf_id = pdf_id;
      this.tbl_id = tbl_id;

      this.SaveProduct2();
    },

    async SaveProduct2() {
      console.log(this.file)
      console.log(this.tbl_id);
   
      if (!this.file) {
        alert("Please select a file first.");
        return;
      }

      if (this.file.type.includes("pdf")) {
        this.showPopup = true;
        await this.renderPDF(this.file);
      } else {
        alert("Only PDF supported for crop OCR here.");
      }
    },

    async renderPDF(file) {
  const reader = new FileReader();

  reader.onload = async (e) => {
    const typedarray = new Uint8Array(e.target.result);
    const pdf = await window.pdfjsLib.getDocument({ data: typedarray }).promise;

    // get FIRST page only
    const page = await pdf.getPage(1);
    const viewport = page.getViewport({ scale: 2 });

    const canvas = document.createElement("canvas");
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    canvas.style.border = "1px solid #ccc";

    const ctx = canvas.getContext("2d");

    await page.render({
      canvasContext: ctx,
      viewport: viewport,
    }).promise;

    // clear popup body
    const popupBody = this.$el.querySelector(".popup-body");
    popupBody.innerHTML = "";
    popupBody.appendChild(canvas);

    // save reference
    this.firstPageCanvas = canvas;
  };

  reader.readAsArrayBuffer(file);
},
    // --- Selection helpers ---
    startSelection(e, canvas, bufferCanvas) {
      this.isSelecting = true;
      const rect = canvas.getBoundingClientRect();
      this.selection = {
        canvas,
        bufferCanvas,
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
        w: 0,
        h: 0,
      };
    },

    drawSelection(e, canvas, bufferCanvas) {
      if (!this.isSelecting || !this.selection) return;
      const rect = canvas.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      this.selection.w = x - this.selection.x;
      this.selection.h = y - this.selection.y;

      // redraw from buffer
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(bufferCanvas, 0, 0);

      // draw selection rectangle
      ctx.save();
      ctx.strokeStyle = "red";
      ctx.lineWidth = 2;
      ctx.setLineDash([6]);
      // draw rect with support for negative w/h (dragging left/up)
      const sx = this.selection.w < 0 ? this.selection.x + this.selection.w : this.selection.x;
      const sy = this.selection.h < 0 ? this.selection.y + this.selection.h : this.selection.y;
      const sw = Math.abs(this.selection.w);
      const sh = Math.abs(this.selection.h);
      ctx.strokeRect(sx, sy, sw, sh);
      ctx.restore();
    },

     endSelection(e, canvas, bufferCanvas) {
      if (!this.selection) return;
      this.isSelecting = false;

      // normalize selection coordinates (so width/height are positive)
      let { x, y, w, h } = this.selection;
      const sx = w < 0 ? x + w : x;
      const sy = h < 0 ? y + h : y;
      const sw = Math.abs(w);
      const sh = Math.abs(h);

      // small area guard
      if (sw < 5 || sh < 5) {
        this.selection = null;
        // redraw full page without box
        const ctx = canvas.getContext("2d");
        ctx.drawImage(bufferCanvas, 0, 0);
        return;
      }

      this.selection = { canvas, bufferCanvas, x: sx, y: sy, w: sw, h: sh };

      // final draw of rectangle
      const ctx = canvas.getContext("2d");
      ctx.drawImage(bufferCanvas, 0, 0);
      ctx.save();
      ctx.strokeStyle = "red";
      ctx.lineWidth = 2;
      ctx.setLineDash([6]);
      ctx.strokeRect(sx, sy, sw, sh);
      ctx.restore();
    },

    // --- OCR pipeline ---
async runOcr() {
  if (!this.firstPageCanvas) {
    alert("PDF not loaded");
    return;
  }

  this.firstPageCanvas.toBlob(async (blob) => {
    let formData = new FormData();
    formData.append("file", blob, "page1.png");

    try {
      const response = await axios.post(
        "/mproduct/scan",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log(response.data);
      this.ocrText = response.data.ocr_text || "";
      this.ocr_ref = response.data.ocr_ref || "";
      this.ocr_auth_date = response.data.ocr_auth_date || "";

    } catch (error) {
      console.log("===== OCR ERROR =====");

      if (error.response) {
        console.log("Status:", error.response.status);
        console.log("Backend error:", error.response.data);
        alert("Backend Error: " + JSON.stringify(error.response.data));
      } else {
        alert(error.message);
      }
    }
  }, "image/png");
},



    async confirmOcr() {
      this.alldata10.number = this.ocr_auth_date;
      this.alldata10.ref = this.ocr_ref;
      this.showPopup = false;
      this.ocrText = "";
      this.selection = null;


     const formData2 = new FormData();
formData2.append("task_file", this.file);
formData2.append("tbl_id", this.tbl_id);
formData2.append("pdf_id", this.pdf_id);
formData2.append("id", this.id);
formData2.append("date", this.alldata10.number);
formData2.append("ref", this.alldata10.ref);



         try {
       // this.isLoading = true;
        const { data } = await axios.post('/mproduct/updatedate', formData2,{

          headers: {
            'Authorization': 'Bearer ' + this.access_token,
           // 'Content-type': 'application/json',
          }
        });
        console.log(data);
        if(data.status==200){
      this.loadMiinventory();
        }



        // this.isLoading = false;
      } catch (error) {
        console.log(error.response);
      }




    },

    closePopup() {
      this.showPopup = false;
      this.selection = null;
      this.ocrText = "";
    },

    // --- Image processing helpers (simple, pure JS) ---
   
  

       exportTableToExcel() {
  const workbook = XLSX.utils.book_new();
  let hasData = false;

  const tables = [
    { active: this.table1, data: this.all_data_arl, fields: this.visibleFieldsarl, name: 'ARL' },
    { active: this.table2, data: this.all_data_ad, fields: this.visibleFieldsad, name: 'AD' },
    { active: this.table3, data: this.all_data_mpdjan, fields: this.visibleFieldsmpdjan, name: 'MPD JAN' },
    { active: this.table4, data: this.all_data_mpdsep, fields: this.visibleFieldsmpdsep, name: 'MPD SEP' },
  ];

  tables.forEach(table => {
    if (table.active && table.data.length > 0) {
      const exportData = table.data.map(row => {
        const item = {};
        table.fields.forEach(field => {
          item[field.label] = row[field.key];
        });
        return item;
      });

      const worksheet = XLSX.utils.json_to_sheet(exportData);

      // 👇 Set custom column widths
      worksheet['!cols'] = table.fields.map(field => ({
        wch: field.label.length + 5 // width based on header text + padding
      }));

      XLSX.utils.book_append_sheet(workbook, worksheet, table.name);
      hasData = true;
    }
  });

  if (!hasData) {
    alert("No data to export.");
    return;
  }

  const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([wbout], { type: "application/octet-stream" });
  saveAs(blob, "Exported_Tables.xlsx");
},



          async loadsavefile(id){
      this.$router.push('/Pdf/indexload?id='+id);
      this.id = id;
      this.loadMiinventory(id);
    },
          async tab2(){
      this.$router.push('/Pdfarl/indextab1');
    },
  async tab3(){
      this.$router.push('/pdf/index');
    },
  async tab4(){
      this.$router.push('/Pdfmdpjan/index');
    },

    async tab5(){
      this.$router.push('/Pdfmdpsep/index');
    },
    async tab6(){
      this.$router.push('/Pdf/indexsearch');
    },


          Savedata(){

             this.infoModal.content = 1;
              this.$root.$emit('bv::show::modal', this.infoModal.id)
          },

    getFilteredFiles(currentIndex) {
  const selectedValues = this.rows
    .map((row, i) => i !== currentIndex ? (row.selectfile && row.selectfile.value) : null)
    .filter(val => val !== null);

  return this.Fileselcts.filter(option => !selectedValues.includes(option.value));
},

  addRow() {
    this.rows.push({
      selectfile: null,
      selecttab: [],
      keyword: ''
    });
  },
   removeRow(index) {
    this.rows.splice(index, 1);
  },
  loadtab(rowIndex) {
    // Optional: you can react to file change per row
    console.log('File changed in row', rowIndex);
  },



   async Remove() {



      try {
       // this.isLoading = true;
        const { data } = await axios.post('/mproduct/removeitem',{all_data_arl:this.all_data_arl,all_data_ad:this.all_data_ad,all_data_mpdjan:this.all_data_mpdjan,all_data_mpdsep:this.all_data_mpdsep,filename:this.filename,userid:this.userid}, {

          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          }
        });
        console.log(data);
        if(data.status==200){
           console.log(data);
          this.loadMiinventory();

        }



        // this.isLoading = false;
      } catch (error) {
        console.log(error.response);
      }
    },




             async Savefile() {



      try {
       // this.isLoading = true;
        const { data } = await axios.post('/mproduct/pdfsave',{all_data_arl:this.all_data_arl,all_data_ad:this.all_data_ad,all_data_mpdjan:this.all_data_mpdjan,all_data_mpdsep:this.all_data_mpdsep,filename:this.filename,userid:this.userid}, {

          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          }
        });
        console.log(data);
        if(data.status==200){
   this.$root.$emit('bv::hide::modal', this.infoModal.id);


        }



        // this.isLoading = false;
      } catch (error) {
        console.log(error.response);
      }
    },

            async loadMiinventory(id=this.id) {

          this.table1 = false;
          this.table2 = false;
          this.table3 = false;
          this.table4 = false;

      try {
       // this.isLoading = true;
        const { data } = await axios.post('/mproduct/pdfsaveload',{id:id}, {

          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          }
        });
        console.log(data);
        if(data.status==200){
        this.all_data_arl = data.all_data_arl;
        this.totalRowsarl = data.totalRowsarl;
          this.all_data_ad = data.all_data_ad;
          this.totalRowsad = data.totalRowsad;
           this.all_data_mpdjan = data.all_data_mpdjan;
          this.totalRowsmpdjan = data.totalRowsmpdjan;
           this.all_data_mpdsep = data.all_data_mpdsep;
          this.totalRowsmpdsep = data.totalRowsmpdsep;

           if(this.totalRowsarl>0){
          this.table1 = true;

        }
         if(this.totalRowsad>0){

          this.table2 = true;
                }
         if(this.totalRowsmpdjan>0){

          this.table3 = true;

        }
         if(this.totalRowsmpdsep>0){

          this.table4 = true;
        }
        }



        // this.isLoading = false;
      } catch (error) {
        console.log(error.response);
      }
    },

            async loaddata() {

            console.log(this.rows);

      try {
       // this.isLoading = true;
        const { data } = await axios.post('/mproduct/pdffilenameload',{

          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          }
        });
        console.log(data);
        if(data.status==200){
this.pdffiles = data.pdffile
        }



        // this.isLoading = false;
      } catch (error) {
        console.log(error.response);
      }
    },

async loadcoulm(row) {
  const selectfile = row.selectfile && row.selectfile.value;
  const selecttab = row.selecttab;
  console.log(selectfile);
  const columns = [];
 let tempColumns = [];
   const hasColumn = (value) => columns.some(col => col.value === value);
  if (selectfile == 'arl') {

    selecttab.forEach((item, index) => {
      console.log(`Item ${index}:`, item.value);

      if (item.value == 'A_FLIGHT_DECK' || item.value == 'B_FLIGHT_DECK' || item.value == 'C_FLIGHT_DECK'  || item.value == 'D_FLIGHT_DECK' || item.value == 'E_FLIGHT_DECK'  || item.value == 'F_FLIGHT_DECK' || item.value == 'G_FLIGHT_DECK' || item.value == 'H_FLIGHT_DECK'  || item.value == 'I_FLIGHT_DECK'  || item.value == 'J_FLIGHT_DECK'  || item.value == 'X_FLIGHT_DECK'  || item.value == 'Z_FLIGHT_DECK') {
        tempColumns = [
          { value: 'mpd_mid', label: 'MPD MID' },
          { value: 'part_num_dis', label: 'Part Number Part Description' },
          { value: 'cage_code', label: 'Used On/Alt Authority Cage Code/SRC/ATA/LL/PV/AD' },
          { value: 'qty', label: 'Qty' },
          { value: 'serial', label: 'Serial/Lot Number/Dates' },
          { value: 'misc_loc', label: 'Misc Loc/Ref Designator X-Station/Y-BL/Z-Wtr' }
      ];
      }



     tempColumns.forEach(col => {
        if (!hasColumn(col.value)) {
          columns.push(col);
        }
      });
    });

    console.log("Columns:", columns);
    row.sectioncolum = columns;
  }else if(selectfile == 'airworthiness_directive'){
      selecttab.forEach((item, index) => {
      console.log(`Item ${index}:`, item.value);

      if (item.value == '1' || item.value == '2' || item.value == '3') {
        tempColumns = [
          { value: 'ad_number', label: 'AD Number Effective Date' },
          { value: 'amendment', label: 'Amendment' },
          { value: 'assigned', label: 'Assigned to' },
          { value: 'subject', label: 'Subject' },
          { value: 'compliance', label: 'Compliance/Limitations' },
          { value: 'additional_information', label: 'Follow-on Action / Additional Information' }
      ];
      }else if(item.value == '4'){
         tempColumns = [
          { value: 'ad_number', label: 'AD Number Effective Date' },
          { value: 'amendment', label: 'Amendment' },
          { value: 'assigned', label: 'Assigned to' },
          { value: 'subject', label: 'Subject' },

          { value: 'additional_information', label: 'Follow-on Action / Additional Information' }
      ];
      }



     tempColumns.forEach(col => {
        if (!hasColumn(col.value)) {
          columns.push(col);
        }
      });
    });

    console.log("Columns:", columns);
    row.sectioncolum = columns;
  }else if(selectfile == 'MPD_01-01-2024' || selectfile == 'MPD_15-09-2024'){
 selecttab.forEach((item, index) => {
      console.log(`Item ${index}:`, item.value);

      if (item.value == 'HIGHLIGHTS') {
        tempColumns = [
          { value: 'section', label: 'Section' },
          { value: 'item', label: 'Item' },
          { value: 'description_of_change', label: 'Description of Change' },

      ];
      }else if(item.value == 'SYSTEMS_AND_POWERPLANT_MAINTENA'){
         tempColumns = [
          { value: 'item_number', label: 'MPD ITEM NUMBER' },
          { value: 'amm_reference', label: 'AMM REFERENCE' },
          { value: 'cat', label: 'CAT' },
          { value: 'task', label: 'TASK' },
          { value: 'thres', label: 'THRE S.' },
          { value: 'repeat', label: 'REPEAT' },
          { value: 'zone', label: 'ZONE' },
          { value: 'access', label: 'ACCESS' },
          { value: 'apl', label: 'APL' },
          { value: 'eng', label: 'ENG' },
          { value: 'main_hours', label: 'MAIN-HOURS' },
          { value: 'description_of_change', label: 'TASK DESCRIPTION' }
      ];
      }else if(item.value == 'STRUCTURAL_MAINTENANCE_PROGRAM'){
         tempColumns = [
          { value: 'item_number', label: 'MPD ITEM NUMBER' },
          { value: 'amm_reference', label: 'AMM REFERENCE' },
          { value: 'pgm', label: 'PGM' },

          { value: 'thres', label: 'THRE S.' },
          { value: 'repeat', label: 'REPEAT' },
          { value: 'zone', label: 'ZONE' },
          { value: 'access', label: 'ACCESS' },
          { value: 'apl', label: 'APL' },
          { value: 'eng', label: 'ENG' },
          { value: 'main_hours', label: 'MAIN-HOURS' },
          { value: 'description_of_change', label: 'TASK DESCRIPTION' }
      ];
      }else if(item.value == 'ZONAL_INSPECTION_PROGRAM'){
         tempColumns = [
          { value: 'item_number', label: 'MPD ITEM NUMBER' },
          { value: 'amm_reference', label: 'AMM REFERENCE' },
            { value: 'thres', label: 'THRE S.' },
          { value: 'repeat', label: 'REPEAT' },
          { value: 'zone', label: 'ZONE' },
          { value: 'access', label: 'ACCESS' },
          { value: 'apl', label: 'APL' },
          { value: 'eng', label: 'ENG' },
          { value: 'main_hours', label: 'MAIN-HOURS' },
          { value: 'description_of_change', label: 'TASK DESCRIPTION' }
      ];
      }else if(item.value == 'TASKS_SORTED_BY_INTERVAL'){
         tempColumns = [


            { value: 'thres', label: 'THRE S.' },
          { value: 'repeat', label: 'REPEAT' },
             { value: 'item_number', label: 'MPD ITEM NUMBER' },
          { value: 'task_title', label: 'TASK TITLE' },

      ];
      }else if(item.value == 'TASKS_SORTED_BY_MPD_ITEM_NUMBER'){
         tempColumns = [
          { value: 'item_number', label: 'MPD ITEM NUMBER' },
          { value: 'mrb_item_number', label: 'MRB ITEM NUMBER' },
          { value: 'task_card_number', label: 'TASK CARD NUMBER' },
          { value: 'related_task_card_number', label: 'RELATED TASK CARD NUMBER' },
          { value: 'task', label: 'TASK' },
          { value: 'task_title', label: 'TASK TITLE' },

      ];
      }else if(item.value == 'TASKS_SORTED_BY_MRB_ITEM_NUMBER'){
         tempColumns = [
           { value: 'mrb_item_number', label: 'MRB ITEM NUMBER' },
          { value: 'item_number', label: 'MPD ITEM NUMBER' },

          { value: 'task_card_number', label: 'TASK CARD NUMBER' },
          { value: 'related_task_card_number', label: 'RELATED TASK CARD NUMBER' },
          { value: 'task', label: 'TASK' },
          { value: 'task_title', label: 'TASK TITLE' },

      ];
      }else if(item.value == 'TASKS_SORTED_BY_TASK_CARD_NUMBE'){
         tempColumns = [
              { value: 'task_card_number', label: 'TASK CARD NUMBER' },
                { value: 'item_number', label: 'MPD ITEM NUMBER' },
           { value: 'mrb_item_number', label: 'MRB ITEM NUMBER' },



          { value: 'related_task_card_number', label: 'RELATED TASK CARD NUMBER' },
          { value: 'task', label: 'TASK' },
          { value: 'task_title', label: 'TASK TITLE' },

      ];
      }



     tempColumns.forEach(col => {
        if (!hasColumn(col.value)) {
          columns.push(col);
        }
      });
    });

    console.log("Columns:", columns);
    row.sectioncolum = columns;
  }
},




   async loadtab(row) {
  const selectedValue = row.selectfile && row.selectfile.value;

    if (selectedValue === 'detailed_specification') {
      row.sections = [
        { label: 'Section 1', value: 'section1' },
        { label: 'Section 2', value: 'section2' },
        { label: 'Section 3', value: 'section3' },
        { label: 'Section 4', value: 'section4' }
      ];
    } else if (selectedValue === 'arl') {
      row.sections = [
        { label: 'Section A', value: 'A_FLIGHT_DECK' },
        { label: 'Section B', value: 'B_FLIGHT_DECK' },
        { label: 'Section C', value: 'C_FLIGHT_DECK' },
        { label: 'Section D', value: 'D_FLIGHT_DECK' },
        { label: 'Section E', value: 'E_FLIGHT_DECK' },
        { label: 'Section F', value: 'F_FLIGHT_DECK' },
        { label: 'Section G', value: 'G_FLIGHT_DECK' },
        { label: 'Section H', value: 'H_FLIGHT_DECK' },
        { label: 'Section I', value: 'I_FLIGHT_DECK' },
        { label: 'Section J', value: 'J_FLIGHT_DECK' },
        { label: 'Section X', value: 'X_FLIGHT_DECK' },
        { label: 'Section Z', value: 'Z_FLIGHT_DECK' }
      ];
    } else if (selectedValue === 'airworthiness_directive') {
      row.sections = [
        { label: 'Section 1', value: 1 },
        { label: 'Section 2', value: 2 },
        { label: 'Section 3', value: 3 },
        { label: 'Section 4', value: 4 }
      ];
    } else if (selectedValue === 'MPD_01-01-2024' || selectedValue === 'MPD_15-09-2024') {
      row.sections = [
        { label: 'HIGHLIGHTS', value: 'HIGHLIGHTS' },
        { label: 'SYSTEMS AND POWERPLANT MAINTENA', value: 'SYSTEMS_AND_POWERPLANT_MAINTENA' },
        { label: 'STRUCTURAL MAINTENANCE PROGRAM', value: 'STRUCTURAL_MAINTENANCE_PROGRAM' },
        { label: 'ZONAL INSPECTION PROGRAM', value: 'ZONAL_INSPECTION_PROGRAM' },
        { label: 'TASKS SORTED BY INTERVAL', value: 'TASKS_SORTED_BY_INTERVAL' },
        { label: 'TASKS SORTED BY MPD ITEM NUMBER', value: 'TASKS_SORTED_BY_MPD_ITEM_NUMBER' },
        { label: 'TASKS SORTED BY MRB ITEM NUMBER', value: 'TASKS_SORTED_BY_MRB_ITEM_NUMBER' },
        { label: 'TASKS SORTED BY TASK CARD NUMBER', value: 'TASKS_SORTED_BY_TASK_CARD_NUMBE' }
      ];
    } else {
      row.sections = []; // default empty
    }

    // Clear selected tabs when file changes
    row.selecttab = [];
  },


    async SaveProduct() {
  if (!this.file) {
    alert("Please select an Excel file first.");
    return;
  }
  console.log(this.alldata.select);
  const formData = new FormData();
  formData.append("excel_file", this.file);
  formData.append("select_value", JSON.stringify(this.alldata.select));


  try {
    const response = await axios.post(
      "/mproduct/createexcelpdfmdp",
      formData,
      {
        headers: {
          Authorization: "Bearer " + this.access_token,
        "Content-Type": "multipart/form-data",
        //'Content-type': 'application/json',
        },
      }
    );

    const data = response;
      console.log(data);
    if (data.status == 200) {
      alert("Product data uploaded successfully!");
     // window.location.reload();

    } else {
      console.error("Upload failed:", data.message || data);
      alert("Upload failed. Please check the file format or server logs.");
    }
  } catch (error) {
    console.error("Upload error:", error.response || error);
    alert("An error occurred while uploading the file.");
  }
}





    },

    }

    </script>

    <style scoped>
.vs__dropdown-toggle {
      border-radius: 10px !important;
    border-top-left-radius: 10px !important;
    border-top-right-radius: 10px !important;
    border-bottom-right-radius: 10px !important;

}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.popup-card {
  background: #fff;
  width: 80%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
}
canvas {
  border: 1px solid #ccc;
  cursor: crosshair;
}

.popup-header {
  background: #f8f9fa;
  border-bottom: 1px solid #ddd;
  padding: 10px;
}


/* Scrollable middle section */
.popup-body {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}

/* Fixed footer */
.popup-footer {
  background: #fff;
  border-top: 1px solid #ddd;
  padding: 10px;
  width: 500px;
  align-items: center;
  justify-content: space-between; /* OCR input left, buttons right */
}
.ocr-box {
  flex: 1;
  margin-right: 15px;
}
.chose-font {
 font-size: smaller !important;
}

    </style>
